import React from "react";
import "./HomeNewsletterSection.css";

function HomeNewsletterSection() {
  return (
    <section className="newsletter-section">
      <div className="newsletter-inner">
        <h2 className="newsletter-title">
          Get 20% off your first order
        </h2>

        <p className="newsletter-subtitle">
          Join our email list for exclusive offers and the latest news.
        </p>

        <form className="newsletter-form">
          <input
            type="email"
            placeholder="Email"
            className="newsletter-input"
            required   
          />

          <button type="submit" className="newsletter-btn">
            <span className="newsletter-btn-text">SUBSCRIBE</span>
          </button>
        </form>
      </div>
    </section>
  );
}

export default HomeNewsletterSection;